export { default } from './PayatallCash'



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/PayatallCash/index.js